module.exports = __webpack_public_path__ + "img/百香果14.7a69825d.png";